@if(currentRouteDay() && currentRouteDay()?.length > 0){
    @for(item of currentRouteDay(); track item.id) {
        @if(false && isFiturPolylines(item)){
            @if(item.fiturPolylinesPath?.bus?.length > 0){
                <map-polyline [path]="swapLatLng(item.fiturPolylinesPath.bus)" [options]="blueSolidPolylineOptions" />
                <map-polyline [path]="swapLatLng(item.fiturPolylinesPath.bus)" [options]="borderPolylineOptions" />
            }
            @if(item.fiturPolylinesPath?.metro?.length > 0){
                <map-polyline [path]="swapLatLng(item.fiturPolylinesPath.metro)" [options]="redSolidPolylineOptions" />
                <map-polyline [path]="swapLatLng(item.fiturPolylinesPath.metro)" [options]="borderPolylineOptions" />
            }
            @if(item.fiturPolylinesPath?.walking.length > 0){
                <map-polyline [path]="swapLatLng(item.fiturPolylinesPath?.walking)" [options]="dottedPolylineOptions" />
            }
        } @else {
            <map-polyline [path]="item.polylinesPath" [options]="blueSolidPolylineOptions" />
            <map-polyline [path]="item.polylinesPath" [options]="borderPolylineOptions" />
        }

    }
}